import { MatMenuModule } from '@angular/material/menu';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { FiNewsFeedEditMobileService } from './edit-mobile.service';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { FiReplaceWithLinksModule } from '@fi-app/shared/fi-directives/replace-with-links/replace-with-links.module';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { NewsFeedEditMobileDialogComponent } from './edit-mobile-dialog.component';
import { FiDisableLinksModule } from '@fi-app/shared/fi-directives/disable-links/disable-links.module';
import { FiAppTextSharedModule } from '@fi-shared/app-text';
import { NewsFeedEditMobileSelectFileDialog } from './select-file-dialog/select-file-dialog.component';
import { FiClickTriggerForModule } from '@fi-app/utilities/click-trigger-for/click-trigger-for.module';
import { UtilitiesModule } from '@fi-app/utilities/utilities.module';
import { FiMobileAppHelpersModule } from '@fi-app/mobile-app-helpers/mobile-app-helpers.module';
import { FiBtnUploadFileModule } from '@fi-shared/fi-insert-media/btn-upload-file/btn-upload-file.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { FormsModule } from '@angular/forms';
import { FiContenteditableModelModule } from '@fi-shared/contenteditable-model/contenteditable-model.module';
import { FiTextEditorModule } from '@fi-shared/text-editor/text-editor.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatDialogModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        FiProfileIconModule,
        FiContenteditableModelModule,
        FiReplaceWithLinksModule,
        FiAutofocusModule,
        FiDisableLinksModule,
        FiTextEditorModule,
        FiAppTextSharedModule,
        FiClickTriggerForModule,
        UtilitiesModule,
        FiMobileAppHelpersModule,
        FiBtnUploadFileModule,
        FiAttachmentsModule,
    ],
    declarations: [NewsFeedEditMobileDialogComponent, NewsFeedEditMobileSelectFileDialog],
    providers: [FiNewsFeedEditMobileService],
})
export class FiNewsFeedEditMobileModule {}
